export default __webpack_public_path__ + "static/latest-news-0736f3b94ba477f07ac5ca24eed2175b.webp";